import { injectable } from "inversify";
import ValidationService from "../ValidationService";

@injectable()
export default class BankAccountValidator {
  // vahy cisel - vyhlaska c. 169/2011 Sb. (CNB)
  private readonly _weights = [6, 3, 7, 9, 10, 5, 8, 4, 2, 1];

  private readonly _validationService: ValidationService;

  constructor() {
    this._validationService = new ValidationService();
  }

  validatePreAccountNumber(preAccountNumber: string, validateRegex: boolean = true): boolean {
    if (validateRegex && !this._validationService.validateRegex(preAccountNumber, /^\d{0,6}/)) {
      return false;
    }

    return this.isValidNumber(preAccountNumber);
  }

  validateAccountNumber(accountNumber: string, validateRegex: boolean = true): boolean {
    if (validateRegex && !this._validationService.validateRegex(accountNumber, /^\d{2,10}/)) {
      return false;
    }

    return this.isValidNumber(accountNumber);
  }

  private isValidNumber(number: string) {
    number = number ?? "";
    let prefix = number.padStart(10, "0");
    let checkSum = 0;

    for (let i = 0; i < prefix.length; i++) {
      checkSum += this._weights[i] * Number(prefix[i]);
    }

    return checkSum % 11 === 0;    
  }
}